module.exports = __webpack_public_path__ + "static/img/Abank.07d78b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Abank.png
// module id = ldXE
// module chunks = 0